import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { virtualAccountService } from "../../services/virtualAccountService";

const initialState = {
  data: null,
  loading: false,
  error: null,
  hasChecked: false, // Add this to track if we've checked for existing account
};

export const fetchVirtualAccount = createAsyncThunk(
  "virtualAccount/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await virtualAccountService.getVirtualAccount();
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch virtual account"
      );
    }
  }
);

export const checkExistingAccount = createAsyncThunk(
  "virtualAccount/check",
  async (_, { rejectWithValue }) => {
    try {
      const response = await virtualAccountService.checkExistingAccount();
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return null; // No account exists
      }
      return rejectWithValue(
        error.response?.data?.message || "Failed to check account status"
      );
    }
  }
);

export const createVirtualAccount = createAsyncThunk(
  "virtualAccount/create",
  async (_, { rejectWithValue }) => {
    try {
      const response = await virtualAccountService.createVirtualAccount();
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to create virtual account"
      );
    }
  }
);

const virtualAccountSlice = createSlice({
  name: "virtualAccount",
  initialState,
  reducers: {
    resetVirtualAccount: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVirtualAccount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVirtualAccount.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchVirtualAccount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(checkExistingAccount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(checkExistingAccount.fulfilled, (state, action) => {
        state.loading = false;
        state.hasChecked = true;
        if (action.payload) {
          state.data = action.payload.data.virtualAccount;
        }
      })
      .addCase(checkExistingAccount.rejected, (state, action) => {
        state.loading = false;
        state.hasChecked = true;
        state.error = action.payload;
      })
      .addCase(createVirtualAccount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createVirtualAccount.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.virtualAccount;
      })
      .addCase(createVirtualAccount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetVirtualAccount } = virtualAccountSlice.actions;
export default virtualAccountSlice.reducer;
